// Organizer authentication for the /organizer portal.
//
// Reuses the same backend app-account login as mobile (POST /api/auth/login,
// GET /api/auth/me) — an activity organizer signs in with their normal OnMyWay
// app credentials. Unlike the admin dashboard (authApi.js) there is NO admin
// role gate: any authenticated user can organize activities.
//
// Kept independent from the admin auth (separate localStorage token) so an
// organizer session and an admin session never clobber each other.

import { getAuthBaseUrl } from './authApi';

const ORG_TOKEN_KEY = 'omw_organizer_token';

export function getOrganizerToken() {
  try {
    return localStorage.getItem(ORG_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setOrganizerToken(token) {
  try {
    localStorage.setItem(ORG_TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearOrganizerToken() {
  try {
    localStorage.removeItem(ORG_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function organizerHeaders() {
  const token = getOrganizerToken();
  const h = { 'Content-Type': 'application/json' };
  if (token) h.Authorization = `Bearer ${token}`;
  return h;
}

export async function organizerLogin(identifier, password) {
  const base = getAuthBaseUrl();
  if (!base) return { success: false, error: 'REACT_APP_API_BASE not configured' };
  try {
    const id = String(identifier || '').trim();
    const res = await fetch(`${base}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: id, identifier: id, password }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { success: false, error: data.error || 'Login failed' };
    return { success: true, user: data.user, token: data.token };
  } catch (e) {
    return { success: false, error: e instanceof Error ? e.message : 'Network error' };
  }
}

export async function organizerMe() {
  const base = getAuthBaseUrl();
  if (!base || !getOrganizerToken()) return { error: 'Not logged in' };
  try {
    const res = await fetch(`${base}/api/auth/me`, { headers: organizerHeaders() });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { error: data.error || 'Not logged in' };
    return { user: data.user };
  } catch (e) {
    return { error: e instanceof Error ? e.message : 'Network error' };
  }
}
